/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { BetComponent } from '../../../Bet/index';
import UserLink from '../../../../links/UserLink';
import { BettingUser, BetView, TournamentRoundGroupMember } from '../../../../services/betting';

interface LeafGridRowProps {
    trgm?: TournamentRoundGroupMember;
    user?: BettingUser;
    bets?: BetView[];
    startColumn: number;
    columnCount: number;
}

export class LeafGridRow extends React.Component<LeafGridRowProps> {
    render() {
        if (this.props.trgm && this.props.bets && this.props.user) {
            return (
                <tr>
                    <td className="py-1 d-none d-md-table-cell">
                        {this.props.trgm.rank}
                        <br />
                        <small className="text-sm-center">({this.props.trgm.absoluteRank})</small>
                    </td>
                    <td className="py-1 align-middle ps-0 pe-0 d-sm-none">
                        <UserLink id={String(this.props.user.id)} name={this.props.user.name} maxWidth={70} />
                    </td>
                    <td className="py-1 align-middle ps-0 pe-0 d-none d-sm-table-cell">
                        <UserLink id={String(this.props.user.id)} name={this.props.user.name} maxWidth={70} />
                    </td>
                    {this.props.bets.map((bet, index) => {
                        if (
                            index >= this.props.startColumn &&
                            index < this.props.startColumn + this.props.columnCount
                        ) {
                            return (
                                <td
                                    key={index}
                                    className="py-1 text-center align-middle text-nowrap border-left ps-1 pe-1 "
                                >
                                    <BetComponent bet={bet} />
                                </td>
                            );
                        }
                        return null;
                    })}
                    <td className="py-1 pe-0 ps-1 border-left align-middle">
                        <span className="btn-r1--points p-0">{this.props.trgm.points}</span>
                    </td>
                </tr>
            );
        } else {
            return null;
        }
    }
}
